module.exports = __webpack_public_path__ + "img/位图(6).160756b7.png";